import { render, staticRenderFns } from "./PushCard.vue?vue&type=template&id=748957ff&scoped=true"
import script from "./PushCard.vue?vue&type=script&lang=js"
export * from "./PushCard.vue?vue&type=script&lang=js"
import style0 from "./PushCard.vue?vue&type=style&index=0&id=748957ff&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748957ff",
  null
  
)

export default component.exports